import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

interface ComponentWrapperProps {
  disabled?: boolean;
}

const ComponentWrapper = styled(motion.div)<ComponentWrapperProps>`
  padding: 8px 12px;
  margin-bottom: 8px;
  background: #11131a;
  border: 1px solid #252a38;
  border-radius: 6px;
  color: #e8eaed;
  font-size: 0.8125rem;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "grab")};
  user-select: none;
  transition: all 0.2s ease;
  opacity: ${(props) => (props.disabled ? 0.55 : 1)};

  &:hover {
    background: ${(props) => (props.disabled ? "#11131a" : "#181b24")};
    border-color: ${(props) => (props.disabled ? "#252a38" : "#6b9fff")};
  }

  &:active {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "grabbing")};
  }
`;

interface DraggableComponentProps {
  type: string;
  name: string;
  disabled?: boolean;
}

const DraggableComponent: React.FC<DraggableComponentProps> = ({
  type,
  name,
  disabled = false,
}) => {
  const handleDragStart = (e: React.DragEvent) => {
    if (disabled) {
      e.preventDefault();
      return;
    }

    e.dataTransfer.setData("application/json", JSON.stringify({ type }));
    e.dataTransfer.effectAllowed = "move";

    // Add a custom drag image
    const dragImage = document.createElement("div");
    dragImage.style.position = "absolute";
    dragImage.style.top = "-1000px";
    dragImage.style.padding = "8px 12px";
    dragImage.style.background = "#11131a";
    dragImage.style.border = "1px solid #6b9fff";
    dragImage.style.borderRadius = "6px";
    dragImage.style.color = "#e8eaed";
    dragImage.textContent = name;
    document.body.appendChild(dragImage);
    e.dataTransfer.setDragImage(dragImage, 0, 0);

    // Clean up the drag image after a short delay
    setTimeout(() => {
      document.body.removeChild(dragImage);
    }, 0);
  };

  return (
    <ComponentWrapper
      disabled={disabled}
      draggable={!disabled}
      onDragStart={disabled ? undefined : handleDragStart}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      {name}
      {disabled && (
        <div
          style={{
            fontSize: "0.7rem",
            color: "#8b919a",
            marginTop: 4,
            fontStyle: "italic",
          }}
        >
          Remove current asset class to re-enable
        </div>
      )}
    </ComponentWrapper>
  );
};

export default DraggableComponent;
